export default "__VITE_ASSET__500cad9b__"